function normalizeAndMatch(term, string) {
  return (
    string?.toLowerCase().includes(term.toLowerCase()) ||
    string?.toLowerCase().replace(/'/,"").includes(term.toLowerCase()) || 
    string?.toLowerCase().replace(/’/,"").includes(term.toLowerCase()) || 
    string?.toLowerCase().replace(/\./,"").includes(term.toLowerCase()) || 
    string?.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(term.toLowerCase()) 
  )
}
export default normalizeAndMatch;